import { render, staticRenderFns } from "./wxScan.vue?vue&type=template&id=323e378c"
import script from "./wxScan.vue?vue&type=script&lang=js"
export * from "./wxScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports